import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { Button, ButtonGroup } from "aible";

import * as viewReducer from "containers/View/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as globalReducer from "containers/App/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

import { isEnabled } from "utils/featureFlags";

import SubView from "components/View/SubView";
import ChatAppViewContainer from "containers/ChatApp/ChatAppView";
import TestChatAppReportView from "components/ChatApp/TestChatAppReportView";

import ExplorationTile from "components/Tiles/ExplorationTile";

class DeploymentViewContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  getHeaders() {
    return ["Project", "Creation", "Contributors", "Subgroups", "Created By"];
  }

  renderDeployments() {
    const {
      data,
      deleteReport,
      handleExplorationPin,
      history,
      pinnedExplorations,
      isReportsLoading,
      selectedFolder,
      isTableauMode,
      getChatMetrics
    } = this.props;

    return (
      <SubView
        {...this.props}
        label="Exploration"
        headers={this.getHeaders()}
        firstTile={<div />}
        firstRow={<div />}
        length={data.length}
        isInfinite={true}
        isLoading={selectedFolder !== undefined && isReportsLoading}
        tileHeight={495}
        renderTile={(columnIndex, style) => {
          const fNext = orderedData[columnIndex].metadata.next
            ? orderedData[columnIndex].metadata.next
            : orderedData[columnIndex].metadata.explorations &&
                Object.keys(orderedData[columnIndex].metadata.explorations).length > 0
              ? orderedData[columnIndex].metadata.explorations[0]
              : {};
          return data && data.length > columnIndex ? (
            <div style={style} key={columnIndex}>
              <ExplorationTile
                /*
              onClick={() =>
                history.push(
                  "/next/" +
                    fNext?.datasetId +
                    "/" +
                    orderedData[columnIndex].id
                )
              }
              */
                onClick={() => {
                  history.push(
                    isTableauMode
                      ? "/project_next/" + orderedData[columnIndex]?.id
                      : "/next/" + fNext?.datasetId + "/" + orderedData[columnIndex].id
                  );
                }}
                handleDelete={() => deleteReport(orderedData[columnIndex].id)}
                handlePin={() => handleExplorationPin(orderedData[columnIndex].id)}
                pinnedExplorations={pinnedExplorations}
                data={orderedData[columnIndex]}
                getChatMetrics={getChatMetrics}
              />
            </div>
          ) : undefined;
        }}
        childrenLength={data.length}
      ></SubView>
    );
  }

  render() {
    const {
      data,
      deleteReport,
      handleExplorationPin,
      history,
      pinnedExplorations,
      isReportsLoading,
      selectedFolder,
      isTableauMode,
      getChatMetrics,
      isDeploymentsTab,
      deploymentViewMode,
      updateDeploymentViewMode
    } = this.props;

    const fData = data.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));

    const orderedData = data.sort((a, b) =>
      pinnedExplorations?.[a?.id] !== undefined && pinnedExplorations?.[b?.id] === undefined
        ? -1
        : pinnedExplorations?.[a?.id] === undefined && pinnedExplorations?.[b?.id] !== undefined
          ? 1
          : pinnedExplorations?.[a?.id] !== undefined && pinnedExplorations?.[b?.id] !== undefined
            ? pinnedExplorations?.[a?.id] > pinnedExplorations?.[b?.id]
              ? 1
              : pinnedExplorations?.[a?.id] < pinnedExplorations?.[b?.id]
                ? -1
                : 0
            : a.created > b.created
              ? -1
              : a.created < b.created
                ? 1
                : 0
    );

    return isDeploymentsTab ? (
      this.renderDeployments()
    ) : (
      <React.Fragment>
        {(isEnabled("aible-optimize") || isEnabled("az-testing")) && (
          <div
            style={{
              padding: "12px 0px 20px",
              justifyContent: "center",
              display: "flex",
              background: "#FFF",
              height: "70px"
              // borderBottom: "1px solid #dddddd",
            }}
          >
            <ButtonGroup>
              <Button
                type="secondary"
                active={deploymentViewMode === "APPS"}
                onClick={() => updateDeploymentViewMode("APPS")}
                style={{
                  width: "150px"
                }}
              >
                {"Apps & Agents"}
              </Button>
              {isEnabled("az-testing") && (
                <Button
                  type="secondary"
                  active={deploymentViewMode === "APPS_TESTING"}
                  onClick={() => updateDeploymentViewMode("APPS_TESTING")}
                  style={{
                    width: "150px"
                  }}
                >
                  {"A/Z Test Monitoring"}
                </Button>
              )}
            </ButtonGroup>
          </div>
        )}
        {isEnabled("az-testing") && deploymentViewMode === "APPS_TESTING" && <TestChatAppReportView />}
        {(!isEnabled("aible-optimize") || deploymentViewMode === "APPS") && <ChatAppViewContainer />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(reportReducer.fetchNextReports()),
  fetchAll: () => dispatch(reportReducer.fetchAllReports()),
  deleteReport: (id) => dispatch(reportReducer.deleteReport(id)),

  updateDeploymentViewMode: (val) => dispatch(viewReducer.updateDeploymentViewMode(val)),

  handleExplorationPin: (id) => dispatch(viewReducer.updateExplorationPin(id)),
  getChatMetrics: (convArr) => dispatch((dispatch, getState) => chatGPTReducer.getChatMetrics(getState(), convArr))
});

const mapStateToProps = (state, ownProps) => {
  return {
    data: viewReducer.getDeployments(state),
    isTile: viewReducer.getIsTile(state),
    isReportsLoading: globalReducer.getIsReportsLoading(state),
    type: viewReducer.getType(state),
    deploymentViewMode: viewReducer.getDeploymentViewMode(state),
    selectedFolder: foldersReducer.getSelectedFolder(state),

    isTableauMode: globalReducer.getIsTableauMode(state),

    pinnedExplorations: viewReducer.getPinnedExplorations(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DeploymentViewContainer);
